import { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Button from '../components/ui/Button';
import FileButton from '../components/ui/FileButton';
import { useNavigate } from 'react-router-dom';
import { uploadPdf } from '../api';
import { pdfResultToDraft } from '../import/pdfImport';
import { putImportDraft } from '../import/importHandoff';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/ui/PageHeader';
import PageBody from '../components/ui/PageBody';
import PageMain from '../components/ui/PageMain';

function CreateArticleUpload() {
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  function handleFileChange(e) {
    const selected = e.target.files[0];

    if (
      selected &&
      selected.type === 'application/pdf'
    ) {
      setFile(selected);
    } else {
      setFile(null);
      alert('Bitte nur PDF-Dateien auswählen');
    }
  }

  async function handleConvertPdf() {
  if (!file) return;

  try {
    setLoading(true);

    const result = await uploadPdf(file);

    // Pictures come back as data URLs; they are staged in the editor like
    // hand-inserted ones (import/pdfImport.js, import/importHandoff.js).
    const draft = await pdfResultToDraft(result);

    navigate('/create-article/manual', {
      state: { importId: putImportDraft(draft) },
    });

  } catch (error) {

    console.error(
      'PDF Fehler:',
      error
    );

    alert(
        error?.message ||
        t('createArticleUpload.convertError')
      );

  } finally {

    setLoading(false);

  }
}
  return (
    <PageLayout
      showSearch
      showAiSearch
    >
      <PageMain className="article-page">
        <PageHeader title={t('createArticleUpload.title')} condensed />

        <PageBody className="page-body--split">
          <div className="maincol markdown-content">
            <div className="pdf-upload-box">
              <i className="fa-solid fa-file-pdf" />
              <h2>
                {t('createArticleUpload.selectPdfTitle')}
              </h2>
              <p>
                {t('createArticleUpload.description')}
              </p>
              <FileButton
                variant="choice"
                accept="application/pdf"
                onChange={handleFileChange}
              >
                <i className="fa-solid fa-upload" />
                {t('createArticleUpload.selectFileButton')}
              </FileButton>

              {file && (
                <div className="pdf-selected">
                  <i className="fa-solid fa-file-pdf" />
                  {file.name}
                </div>
              )}

              {file && (
                <Button
                  variant="choice"
                  disabled={loading}
                  onClick={handleConvertPdf}
                >
                  <i className="fa-solid fa-file-lines" />

                  {loading
                    ? t('createArticleUpload.processingButton')
                    : t('createArticleUpload.createArticleButton')
                  }
                </Button>
              )}

            </div>
          </div>
        </PageBody>

      </PageMain>
    </PageLayout>
  );
}

export default CreateArticleUpload;